import * as React from 'react'
import { observer, inject } from 'mobx-react'
import { withRouter } from 'react-router'
import HttpActionsService from '../../../Services/HttpActionsService'
import LocalizationStore from '../../../Stores/LocalizationStore'
import { Link } from 'react-router-dom'
import { getPaymentScheduleTable } from '../../../Model/PaymentScheduleItemModel'
import { Button } from 'react-bootstrap'
import { PaymentScheduleUpdateView } from '../../PartialViews/Payment/PaymentScheduleUpdateView'
import QuestionnairesStore from '../../../Stores/QuestionnairesStore'
import UserStore from '../../../Stores/UserStore'

export interface IPaymentsScheduleProps {
    httpActionsService: HttpActionsService
    localizationStore: LocalizationStore
    questionnairesStore: QuestionnairesStore
    userStore: UserStore
    match?: object
}

@inject('httpActionsService')
@inject('localizationStore')
@inject('questionnairesStore')
@inject('userStore')
@observer
class PaymentsSchedulePage extends React.Component<IPaymentsScheduleProps> {

    constructor(props: any) {
        super(props)

        if (this.props['match']!['params']['id']) {
            this.props.httpActionsService.getQuestionnaire(this.props['match']!['params']['id'])
        }
    }

    render() {
        const { httpActionsService, questionnairesStore, userStore } = this.props

        let q = questionnairesStore.getItem

        if (!q || !q.credit || !q.credit.creditCondition) {
            return ''
        }

        return (
            <div className="payments-schedule">
                <PaymentScheduleUpdateView />
                {getPaymentScheduleTable(userStore.checkSuperAdmin)}
                <Button
                    onClick={
                        (e) => {
                            httpActionsService
                                .updateCreditConditions(q.credit.creditCondition)
                        }
                    }
                >
                    {this.props.localizationStore!.t!('Update')}
                </Button>
                <Link className="btn-link" to={'/questionnaire/' + this.props['match']!['params']['id']}>
                    {this.props.localizationStore!.t('goToQuestionnaire')}
                </Link>
            </div>
        )
    }
}

export default withRouter(PaymentsSchedulePage)


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/Pages/Payment/PaymentsSchedulePage.tsx